import { isValidDigitNumber } from '../InputNumber/validator';

export default isValidDigitNumber;
